import {
  ADD_BUYER,
  GET_BUYER,
  EDIT_BUYER,
  UPDATE_BUYER_SUCCESS,
  UPDATE_BUYER_FAIL,
  BUYER_INNER,
  DELETE_BUYER,
  GET_BUYER_PAYMENTS,
  ADD_BUYER_SUCCESS,
  ADD_BUYER_FAIL,
  CLEAR_BUYER_STATE,
} from "../Action/addBuyer";

const initialState = {
  buyers: [],

  addBuyerSuccess: "",
  addBuyerFail: "",

  editBuyerSuccess: "",
  editBuyerFail: "",

  buyer_payments: [],
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_BUYER: {
      return { ...state, buyers: [...state.buyers, action.payload] };
    }

    case ADD_BUYER_SUCCESS: {
      return { ...state, addBuyerSuccess: "add Buyer Success" };
    }

    case ADD_BUYER_FAIL: {
      return { ...state, addBuyerFail: "add Buyer Fail" };
    }

    case GET_BUYER: {
      const totalBuyer = action.payload;
      return { ...state, buyers: totalBuyer };
    }

    case EDIT_BUYER: {
      let NewBuyers = state.buyers.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );

      return {
        ...state,
        buyers: NewBuyers,
      };
    }

    case UPDATE_BUYER_SUCCESS: {
      return { ...state, editBuyerSuccess: "edit Buyer Success" };
    }

    case UPDATE_BUYER_FAIL: {
      return { ...state, editBuyerFail: "edit Buyer Fail" };
    }

    case DELETE_BUYER: {
      const after_delete_buyers = state.buyers.filter(
        (buyer) => buyer.id !== action.payload.id
      );
      console.log(after_delete_buyers);
      return { ...state, buyers: after_delete_buyers };
    }
    case BUYER_INNER: {
      return { ...state };
    }
    case GET_BUYER_PAYMENTS: {
      const BuyerPayments = action.payload;
      return { ...state, buyer_payments: BuyerPayments };
    }
    case CLEAR_BUYER_STATE: {
      return {
        ...state,
        addBuyerSuccess: "",
        addBuyerFail: "",
        editBuyerSuccess: "",
        editBuyerFail: "",
      };
    }

    default:
      return state;
  }
}

export default accountReducer;
// state.filter((post)=>post.id !== action.id)
